<form novalidate *ngIf="premiumQuestions" [formGroup]="premiumLeadForm" (ngSubmit)="submitForm(premiumLeadForm.value)">
	<div class="field" *ngFor="let key of premiumQuestionKeys; index as i">
		<div class="wrapper is-flex-tablet is-block-mobile" *ngIf="! premiumQuestions[key]['hidden']">
			<label class="label">
				<span class="icon">
					<i [class]="premiumQuestions[key]['icon']"></i>
				</span>

				{{ premiumQuestions[key]['text'] }}
			</label>

			<div class="control buttons is-block">
				<button
					type="button"
					*ngFor="let button of premiumQuestions[key]['buttons']"
					class="button has-shadow-small"
					[ngClass]="[premiumLeadControls[key]['value'] === button.text ? 'is-success' : 'is-light']"
					(click)="submitControl(key, button.text)"
				>
					<span class="icon">
						<i [class]="button.text === 'Yes' || button.text === 'Other' ? 'far fa-check-circle' : 'far fa-times-circle'"></i>
					</span>

					{{ button.text }}
				</button>

				<input type="hidden" [formControlName]="key" [value]="premiumLeadControls[key]['value']">

				<p class="help is-danger" *ngIf="invalidSubmission && premiumLeadControls[key]['value'] === '' && premiumLeadControls[key].errors?.required">
					An answer is required for this question.
				</p>
			</div>
		</div>
	</div>

	<div class="field">
		<div class="control">
			<button type="submit" class="button is-success is-fullwidth is-size-4 is-size-5-mobile has-text-weight-black has-shadow-large" [disabled]="! premiumLeadForm.valid || disableSubmit">View Your Rates &#12297;</button>
		</div>
	</div>

	<div class="field">
		<p class="tcpa is-size-7 has-text-grey-dark">
			<input type="hidden" id="tcpa_disclosure">
			<label for="tcpa_disclosure">
				We take your privacy seriously. By clicking the button above, you are providing your <b>express written consent</b> to have your information shared and to be matched with up to five <a href="/landing/approved_lenders.php" target="_new" rel="nofollow">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our <a href="/privacy_policy.php" target="_new" rel="nofollow">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender. ##
			</label>
		</p>

		<p class="is-flex is-flex-centered">
				<img src="/assets/images/bbb-a-plus-rating.gif" alt="BBB A+ Rated">
		</p>
	</div>
</form>

<article class="message is-danger" *ngIf="invalidSubmission">
	<div class="message-header">
		<p>{{ responseErrors.status || 'error' }}</p>
		<button class="delete" aria-label="delete"></button>
	</div>

	<div class="message-body">
		{{ responseErrors.message || 'Invalid submission.' }}
	</div>
</article>
